import React from "react";
import { Button, Dropdown, Flex } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";

type ExportToFile = {
  userRole: any;
  name: string;
  action: () => void;
  options: { key: string; label: string }[];
  onOptionAction?: (event: any) => void;
};

type CreateAction = {
  name: string;
  action: () => void;
};

export type CreateExportConfig = {
  create?: CreateAction;
  exportToFile?: ExportToFile;
};

type CreateAndExportProps = {
  createExportConfig: CreateExportConfig;
};

const ExportMenuOptions = (props: { exportToFile: ExportToFile }) => {
  const { exportToFile } = props;
  const hasOptions = exportToFile.options.length > 0;

  if (!hasOptions) {
    return <Button onClick={exportToFile.action}>{exportToFile.name}</Button>;
  }
  return (
    <Dropdown.Button
      onClick={exportToFile.action}
      trigger={["click"]}
      icon={<CaretDownOutlined />}
      menu={{
        items: exportToFile.options,
        onClick: (event) => {
          if (exportToFile.onOptionAction) {
            exportToFile.onOptionAction(event);
          }
        },
      }}
    >
      {exportToFile.name}
    </Dropdown.Button>
  );
};

export function CreateAndExport(props: CreateAndExportProps) {
  const { createExportConfig } = props;
  const { create, exportToFile } = createExportConfig;

  // const isAdminRole = exportToFile?.userRole == userRoles.ADMIN;
  // const canUseExport = isAdminRole && exportToFile?.name;

  return (
    <Flex gap={6}>
      {create && (
        <Button type="primary" onClick={() => create?.action()}>
          {create?.name}
        </Button>
      )}
      {/* {canUseExport && <ExportMenuOptions exportToFile={exportToFile} />} */}
    </Flex>
  );
}
